import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import SocketContext from "../../contexts/SocketContext";

const ProdSelector = ({
  singleProdNameData,
  setSelectedProducer,
  setShowProdDetails,
  setSelectedProduct,
  selectedProducer,
  selectedProduct,
}) => {
  // Socket
  const { socket } = useContext(SocketContext);

  // Leave Product Room Promise
  const leaveroom = (item) => {
    return new Promise((resolve, reject) => {
      socket.emit("leaveproductRoom", selectedProduct.productID);
      resolve();
    });
  };

  // Select Product
  const selectProduct = async () => {
    if (selectedProduct && selectedProduct.productID) {
      await leaveroom(selectedProduct.productID);
    }
  };

  return (
    <div className='prodProducers'>
      {singleProdNameData && Object.keys(singleProdNameData).length > 0 && (
        <h3 style={{ position: "sticky", top: 0, background: "var(--white)" }}>Select Producer:</h3>
      )}
      {singleProdNameData
        ? Object.keys(singleProdNameData)
            .sort()
            .map((key) => {
              if (key !== "null") {
                return (
                  <NavLink
                    to='/admin/products/productdetails'
                    onClick={(e) => {
                      selectProduct();
                      setSelectedProducer(key);
                      setShowProdDetails(true);
                      setSelectedProduct(
                        // singleProdNameData[key][0]["productID"]
                        singleProdNameData[key][0]
                      );
                      if (singleProdNameData) {
                        socket.emit("joinproductRoom", singleProdNameData[key][0]["productID"]);
                      }
                    }}
                    key={key}
                    className={selectedProducer === key && "activeListSelector"}
                  >
                    {key}
                  </NavLink>
                );
              }
            })
        : ""}
    </div>
  );
};

export default ProdSelector;
